import { readCookie } from '../cookie';

export const isUserRestricted = () => {


  const userDataString = readCookie('userData');
  if (!userDataString) return false;
  try {
    const userData = typeof userDataString === 'string' ? JSON.parse(userDataString) : userDataString;
    const accountType = userData.accountType || '';
    const userTypeName = (userData.userType && userData.userType.name) || '';

    const isSuperOrAdmin =
      accountType === 'Super User' ||
      accountType === 'Admin' ||
      userTypeName === 'Super User' ||
      userTypeName === 'Admin';

    return !isSuperOrAdmin;
  } catch (e) {
    console.error('Error parsing userData cookie', e);
    return false;
  }
};

export const getDefaultProjectFilterName = (projectsList) => {
  // 1. Try reading from currentProjectDetails cookie first
  const currentProjectDetailsStr = readCookie('currentProjectDetails');
  if (currentProjectDetailsStr) {
    try {
      const details = JSON.parse(currentProjectDetailsStr);
      if (details && details.name) {
        return details.name;
      }
    } catch (e) {
      console.error('Error parsing currentProjectDetails cookie', e);
    }
  }

  // 2. Fallback to mapping project_id against the projects list
  const pIdCookie = readCookie('project_id');
  if (!pIdCookie) return null;
  let activeProjectId = '';
  try {
    activeProjectId = typeof pIdCookie === 'string' && (pIdCookie.startsWith('{') || pIdCookie.startsWith('"'))
      ? JSON.parse(pIdCookie)
      : pIdCookie;
  } catch (e) {
    activeProjectId = pIdCookie;
  }
  const projects = projectsList || [];
  const activeProject = projects.find(p => p._id === activeProjectId);
  return activeProject ? activeProject.name : null;
};
